import { render, staticRenderFns } from "./index.vue?vue&type=template&id=056cb7fd"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('056cb7fd')) {
      api.createRecord('056cb7fd', component.options)
    } else {
      api.reload('056cb7fd', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=056cb7fd", function () {
      api.rerender('056cb7fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/post/index.vue"
export default component.exports